module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name
    }
  }, [_c('div', {
    staticClass: "iot"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("物联网智能硬件设备数量:")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "device-wrap"
  }, [_c('div', {
    staticClass: "device-item"
  }, [_c('i', {
    staticClass: "icon icon-device1"
  }), _vm._v(" "), _c('div', {
    staticClass: "device-detail"
  }, [_c('div', {
    staticClass: "device-name"
  }, [_vm._v("监控设备")]), _vm._v(" "), _c('div', {
    staticClass: "device-num"
  }, [_vm._v("1825")])])]), _vm._v(" "), _c('div', {
    staticClass: "device-item"
  }, [_c('i', {
    staticClass: "icon icon-device2"
  }), _vm._v(" "), _c('div', {
    staticClass: "device-detail"
  }, [_c('div', {
    staticClass: "device-name"
  }, [_vm._v("气象站")]), _vm._v(" "), _c('div', {
    staticClass: "device-num"
  }, [_vm._v("990")])])]), _vm._v(" "), _c('div', {
    staticClass: "device-item"
  }, [_c('i', {
    staticClass: "icon icon-device3"
  }), _vm._v(" "), _c('div', {
    staticClass: "device-detail"
  }, [_c('div', {
    staticClass: "device-name"
  }, [_vm._v("传感器")]), _vm._v(" "), _c('div', {
    staticClass: "device-num"
  }, [_vm._v("1490")])])]), _vm._v(" "), _c('div', {
    staticClass: "device-item"
  }, [_c('i', {
    staticClass: "icon icon-device4"
  }), _vm._v(" "), _c('div', {
    staticClass: "device-detail"
  }, [_c('div', {
    staticClass: "device-name"
  }, [_vm._v("控制设备")]), _vm._v(" "), _c('div', {
    staticClass: "device-num"
  }, [_vm._v("765")])])])]), _vm._v(" "), _c('div', {
    staticClass: "monitor"
  }, [_c('div', {
    staticClass: "monitor1"
  }, [(_vm.imgList1.length != 0) ? _c('swiper', {
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.imgList1), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "swiper-item"
    }, [_c('img', {
      staticClass: "slide-img",
      attrs: {
        "src": item.src,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "msg"
    }, [_vm._v(_vm._s(item.name))])])])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList1.length > 1),
      expression: "imgList1.length>1"
    }],
    staticClass: "swiper-button-prev0"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList1.length > 1),
      expression: "imgList1.length>1"
    }],
    staticClass: "swiper-button-next0"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "monitor2"
  }, [(_vm.imgList2.length != 0) ? _c('swiper', {
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption1
    }
  }, _vm._l((_vm.imgList2), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "swiper-item"
    }, [_c('img', {
      staticClass: "slide-img",
      attrs: {
        "src": item.src,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "msg"
    }, [_vm._v(_vm._s(item.name))])])])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList2.length > 1),
      expression: "imgList2.length>1"
    }],
    staticClass: "swiper-button-prev1"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList2.length > 1),
      expression: "imgList2.length>1"
    }],
    staticClass: "swiper-button-next1"
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b316c886!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/iot/index.vue
// module id = 2077
// module chunks = 2